import React from "react";
import * as types from "../../constants/SettingActionTypes"

import "../crmComponents/Contacts.css";
import { ChevronLeft } from "react-bootstrap-icons/dist";
import { useState, useEffect } from "react";
import * as Icon from "react-bootstrap-icons";
import { useParams, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Toast from "../assetLibComponents/shared/Toast";
import { addUser, editUser, fetchUserDetails } from "../../redux/actions/settingActions";
import { Mixpanel } from "../../Mixpanel";
  
  const AddUser = (props) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userDetails = useSelector((state) => state.setting.fetchUserDetails);
    const [fname, setFname] = useState(userDetails?.userList ? userDetails?.userList?.first_name:"");
    const [lname, setLname] = useState(userDetails?.userList ? userDetails?.userList?.last_name:"");
    const [email, setEmail] = useState(userDetails?.userList ? userDetails?.userList?.email:"");
    const [phone, setPhone] = useState(userDetails?.userList ? userDetails?.userList?.mobile:"");
    const [password, setPassword] = useState("");
    const [confirmPass, setConfirmPass] = useState("");
  
    const submitHandler = async (e) => {
      e.preventDefault();
      let newLead;
          newLead = {
            users_id: id ? id:"",
            first_name: fname,
            last_name: lname,
            email: email,
            confirm_password: confirmPass,
            password: password,
            mobile: phone,
          };
  
          const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
          if(fname === ""){
            Toast("Please Enter First Name", "E");
          }else if(lname === ""){
            Toast("Please Enter Last Name", "E");
          }
          else if (password === "" && props.subPageName !== "editUser") {
            Toast("Please Enter Password", "E");
          }else if (confirmPass === "" && props.subPageName !== "editUser") {
            Toast("Please Enter Confirm Password", "E");
          }
          else if (phone === "") {
            Toast("Please Enter Mobile", "E");
          } else if(email === "" || regex.test(email) === false){
            Toast("Please Enter Valid Email", "E");
          } else{
            if(props.subPageName === "addUser"){
              Mixpanel.track("Added team members.")
              dispatch(addUser(props.authToken, newLead, onSuccess));
            }else{
              dispatch(editUser(props.authToken, newLead, onSuccess));
            }
          }
    };
    
    const onSuccess = () => {
      navigate(-1);
    }

    useEffect(() => {
      if(id){
        dispatch(fetchUserDetails(props.authToken, id));
      } else {
        setFname("");
        setLname("");
        setEmail("");
        setPhone("");
      }
    }, [])
    useEffect(() => {
      if(userDetails){
        setFname(userDetails?.userList?.first_name)
        setLname(userDetails?.userList?.last_name)
        setEmail(userDetails?.userList?.email)
        setPhone(userDetails?.userList?.mobile)
      }
    }, [userDetails])

    useEffect(()=>{
      return () => {
        dispatch({ type: types.FETCH_USER_DETAILS, payload: null });
      }
    },[])

  return (
    <>
      <div className="new-contact mt-4 px-10 max-sm:px-2">
        <div className="container min-h-[80vh]">
          <div className="">
            <div>
              <div>
                <div>
                  <div className="mt-4 mb-4">
                    <div className="flex flex-col">
                      <div className="grid grid-cols-11">
                        <div className="mb-5 flex flex-row justify-start items-center gap-1.5 not-italic font-bold text-xs text-right text-[#374151] cursor-pointer" onClick={()=>{navigate("/Setting")}}>
                              <Icon.ChevronLeft className="text-[#000000]"/> <span>Back</span>
                        </div>
                        <div className="col-span-12">
                          <h6 className="mb-8 text-lg font-[600]">
                            Personal Information
                          </h6>
                          <div className="mb-3">
                            <div className="grid grid-cols-12">
                              <div className="col-span-4 flex items-center">
                                <div className="mt-1">
                                  First Name
                                </div>
                              </div>
                              <div className="col-span-8">
                                <input
                                 className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                  type="text"
                                  autoComplete="off"
                                  required
                                  placeholder="First Name"
                                  value={fname}
                                  onChange={(e) => setFname(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>
                          
                          <div className="mb-3">
                            <div className="grid grid-cols-12">
                              <div className="col-span-4 flex items-center">
                                <div className="mt-1">
                                  Last Name
                                </div>
                              </div>
                              <div className="col-span-8">
                                <input
                                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                  type="text"
                                  required
                                  placeholder="Last Name"
                                  value={lname}
                                  onChange={(e) => setLname(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mb-3">
                            <div className="grid grid-cols-12">
                              <div className="col-span-4 flex items-center">
                                <label className="mt-1">Email</label>
                              </div>
                              <div className="col-span-8">
                                <input
                                 className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                  type="email"
                                  required
                                  autoComplete="off"
                                  placeholder="Email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mb-3">
                            <div className="grid grid-cols-12">
                              <div className="col-span-4 flex items-center">
                                <label className="mt-1">Phone Number</label>
                              </div>
                              <div className="col-span-8">
                                <input
                                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                  type="text"
                                  required
                                  autoComplete="off"
                                  placeholder="Phone Number"
                                  value={phone}
                                  onChange={(e) => {
                                  const integerRegex = /^\d+$/; // This regex matches one or more digits
                                  if ((integerRegex.test(e.target.value) || e.target.value === "") && e.target.value.length < 11) {
                                    setPhone(e.target.value)
                                  }
                                }}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mb-3">
                            <div className="grid grid-cols-12">
                              <div className="col-span-4 flex items-center">
                                <label className="mt-1">Password</label>
                              </div>
                              <div className="col-span-8">
                                <input
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                    type="password"
                                    autoComplete="off"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mb-3">
                            <div className="grid grid-cols-12">
                              <div className="col-span-4 flex items-center">
                                <label className="mt-1">Confirm Password</label>
                              </div>
                              <div className="col-span-8">
                                <input
                                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                  type="password"
                                  autoComplete="off"
                                  placeholder="Confirm Password"
                                  value={confirmPass}
                                  onChange={(e) =>
                                    setConfirmPass(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-span-1"></div>
                      </div>
                      <button
                        onClick={submitHandler}
                        type="button"
                        className="ml-auto mt-10 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUser;
